/**
 * Module-level guards so Keycloak/backend auth does not restart on route remounts.
 */

let getKeycloakUrlInFlight = null;
let userInfoSyncInFlight = null;
let keycloakSsoInFlight = null;
let userInfoSynced = false;
let lastSyncedAccessToken = null;

export function getGetKeycloakUrlInFlight() {
  return getKeycloakUrlInFlight;
}

export function setGetKeycloakUrlInFlight(promise) {
  getKeycloakUrlInFlight = promise;
}

export function getUserInfoSyncInFlight() {
  return userInfoSyncInFlight;
}

export function setUserInfoSyncInFlight(promise) {
  userInfoSyncInFlight = promise;
}

export function getKeycloakSsoInFlight() {
  return keycloakSsoInFlight;
}

export function setKeycloakSsoInFlight(promise) {
  keycloakSsoInFlight = promise;
}

function trimTrailingSlashes(value) {
  const str = String(value);
  let end = str.length;
  while (end > 0 && str[end - 1] === '/') {
    end -= 1;
  }
  return str.slice(0, end);
}

export function normalizeKeycloakConfig(config) {
  if (!config || typeof config !== 'object' || Array.isArray(config)) {
    return null;
  }
  const clientId = config.clientId || config.resource;
  if (!config.url || !config.realm || !clientId) {
    return null;
  }
  return {
    ...config,
    url: trimTrailingSlashes(config.url),
    clientId,
  };
}

export function shouldSkipUserInfoSync(accessToken) {
  if (getUserInfoSyncInFlight()) {
    return true;
  }
  if (!userInfoSynced || !accessToken) {
    return false;
  }
  return lastSyncedAccessToken === accessToken;
}

export function markUserInfoSyncSuccess(accessToken) {
  userInfoSynced = true;
  lastSyncedAccessToken = accessToken || null;
}

export function resetAuthFlowState() {
  getKeycloakUrlInFlight = null;
  userInfoSyncInFlight = null;
  keycloakSsoInFlight = null;
  userInfoSynced = false;
  lastSyncedAccessToken = null;
}

export function getAuthenticatedKeycloakTokens() {
  const keycloak = typeof window !== 'undefined' ? window.keycloakAuth : null;
  if (!keycloak || keycloak.authenticated !== true || !keycloak.token) {
    return null;
  }
  return {
    accessToken: keycloak.token,
    idToken: keycloak.idToken,
    refreshToken: keycloak.refreshToken,
  };
}
